<div id="wrapper">
    <header class="app-header">
      <ul class="app-nav">
        <!-- <li class="app-search">
          <input class="app-search__input" type="search" placeholder="Search">
          <button class="app-search__button"><i class="fa fa-search"></i></button>
        </li> -->

        <!--Notification Menu-->
        <li class="dropdown">
          <a class="app-nav__item" href="#" data-toggle="dropdown" aria-label="Show notifications">
            <i class="fa fa-bell-o fa-lg"></i>
          </a>
          <ul class="app-notification dropdown-menu dropdown-menu-right notify">
            <li class="app-notification__title">You have 0 new notifications.</li>
            <div class="app-notification__content">


              <div class="app-notification__content">



              </div>
            </div>
            <li class="app-notification__footer"><a href="javascript:;">See all notifications.</a></li>
          </ul>
        </li>

        <!-- User Menu-->
        <li class="dropdown" *ngIf="applicant"><a class="app-nav__item" href="#" (click)="onLogout($event)" data-toggle="dropdown" aria-label="Open Profile Menu"><i class="fa fa-unlock fa-lg"></i> </a>
          <ul class="dropdown-menu settings-menu dropdown-menu-right">
          </ul>
        </li>

      </ul>
    </header>

    <main class="main-content">

        <div class="app-title">
            <div class="div">
              <h2>University of Mines and Technology (UMaT)</h2>
              <h6>ADMISSION LIST {{academicYear}} ACADEMIC YEAR</h6>
              <h6>ADMISSION STATUS CHECKER</h6>
            </div>

            <!-- <ul class="app-breadcrumb breadcrumb">
              <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
              <li class="breadcrumb-item"><a href="#">Bootstrap Elements</a></li>
            </ul> -->
          </div>

        <router-outlet></router-outlet>

    </main>




    <app-site-footer></app-site-footer>


</div>
